<template>
  <div class="editbox" v-show="!!item">
    <infoSlider :style="{zIndex: 999}" :show="!!item" @close="getAgency=false;$emit('close')"
    :label="storeType==='shop' ? '預購資訊' : '預約資訊'" defaultClass="123" :width="481" :icon="'calendar'"
    :printBtn="storeType==='shop' && '列印明細單'" :btnText="storeType==='shop' && '印明細'" @printInfo="$emit('print')">
      <template slot="header">
        <button id="moveInfo" @click="movingInfo=true" v-if="!item?.paidTime">移動資訊</button>
        </template>
      <div class="editCube">
        <section class="top" label="預約資訊" v-if="storeType==='tickets'">
          <template v-if="item">
          <template v-if="edit!=='guide'">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '15px'}">
              <div class="field">
                <div>預約人數</div>
                <div><span :style="{color: 'var(--highlight)', fontSize: '30px', fontWeight: 500, display: 'inline-flex', width: '80px', justifyContent:'center'}">{{item.reserveNum}}</span> 人</div>
              </div>
              <div class="field">
                <div>導覽需求</div>
                <div v-if="item.guideNeed"><span :style="{color: 'var(--highlight)', fontSize: '30px', fontWeight: 500, display: 'inline-flex', width: '80px', justifyContent:'center'}">{{reduce(item.Orders.filter(e => new RegExp('導覽', 'ig').test(e.name)).map(e => e.count))}}</span> 名</div>
                <div v-else-if="item.guideNeed===false">不需要</div>
                <div v-else>待確認</div>
              </div>
            </div>
            <EditBtnCo @click="edit='guide'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='guide'">
            <div class="field  field-edit">
                <div>預約人數</div>
                <div :style="{display: 'flex'}">
                  <input type="text" v-model="editItem.reserveNum" :style="{width: '80px', textAlign: 'center', marginRight: '1em'}"> 人
                </div>
            </div>
            <div class="field field-edit fieldGu">
                <div>導覽需求</div>
                <div>
                  <label for="need"><input type="radio" v-model="editItem.guideNeed" :value="true" id="need">需要導覽</label>
                  <label for="notneed"><input type="radio" v-model="editItem.guideNeed" :value="false" id="notneed">不需要導覽</label>
                  <label for="unknown"><input type="radio" v-model="editItem.guideNeed" id="unknown">不確定 / 待確認</label>
                </div>
            </div>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
          </template>
        </section>
        <section class="top" label="預約資訊" v-else-if="storeType==='event'">
          <template v-if="item">
          <template v-if="edit!=='guide2'">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '15px'}">
              <div class="field">
                <div>預約人數</div>
                <div :style="{display:'flex', alignItems: 'center'}">
                  <div><span :style="{color: 'var(--highlight)', fontSize: '30px', fontWeight: 500, display: 'inline-flex', width: '80px', justifyContent:'center'}">{{item.reserveNum}}</span> 大</div>
                  <div><span :style="{color: 'var(--highlight)', fontSize: '30px', fontWeight: 500, display: 'inline-flex', width: '80px', justifyContent:'center'}">{{item.reserveNumChild}}</span> 小</div>
                </div>
              </div>
            </div>
            <EditBtnCo @click="edit='guide2'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='guide2'">
            <div class="field  field-edit">
                <div>預約人數</div>
                <div :style="{display:'flex', alignItems: 'center', gap: '10px'}">
                  <div :style="{display: 'flex'}">
                    <input type="text" v-model="editItem.reserveNum" :style="{width: '80px', textAlign: 'center', marginRight: '1em'}"> 大
                  </div>
                  <div :style="{display: 'flex'}">
                    <input type="text" v-model="editItem.reserveNumChild" :style="{width: '80px', textAlign: 'center', marginRight: '1em'}"> 小
                  </div>
                </div>
            </div>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
          </template>
        </section>
        <section class="top" :label="storeType==='shop'?'排單製作':'排單製作'" v-if="item&&storeType==='shop'">
          <template v-if="edit!=='signDate'">
            <div>
              <div class="signDate">
                {{item.productionDate ? toDate(item.productionDate) :'-'}}
              </div>
              <template v-if="item.arranged&&item.arranged.length>0">
              <hr :style="{marginBlock: '17px 10px'}">
              <div class="field-foot" @click="arrangedDisplay=!arrangedDisplay" :title="`點擊${arrangedDisplay ? '收摺' : '展開'}操作紀錄`">
                <div :style="{textAlign:'start'}">操作人員: {{item.arranged[item.arranged.length-1]?.name||'---'}}</div>
                <div :style="{marginLeft: 'auto'}">{{moment(item.arranged[item.arranged.length-1].time).format('yyyy/MM/DD HH:mm')}}</div>
              </div>
              <template  v-if="arrangedDisplay">
                <div class="field-foot" v-for="index in (item.arranged.length-1)" :key="`arranged-${index}`" :style="{marginTop: '8px'}">
                  <div :style="{textAlign:'start'}">操作人員: {{item.arranged[item.arranged.length-index-1]?.name||'---'}}<br>排定日期: {{toDate(item.arranged[item.arranged.length-index-1].productionDate)||'---'}}</div>
                  <div :style="{marginLeft: 'auto'}" v-html="moment(item.arranged[item.arranged.length-index-1].time).format('yyyy/MM/DD<br>HH:mm')"></div>
                </div>
              </template>
              </template>
              <!-- <div class="field-foot" v-else>
                <div :style="{textAlign:'start'}">操作人員: {{item.operator?.name||'---'}}</div>
                <div :style="{marginLeft: 'auto'}">{{moment(item.updateTime).format('yyyy/MM/DD HH:mm')}}</div>
              </div> -->
            </div>
            <EditBtnCo @click="edit='signDate'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='signDate'">
            <div>
              <div><DateInput :style="{width: '360px', margin: 0}" :defaultValue="(editItem.productionDate ? moment(editItem.productionDate).format('yyyy-MM-DD') : null)" @input="editItem.productionDate=$event; "/></div>
            </div>
            <BtnsS @cancel="edit=null" @save="save" :style="{paddingTop: 0}"/>
          </template>
        </section>
        <section class="top" :label="'貨運單號'" v-if="item&&storeType==='shop'&&item.type==='宅配'">
          <template v-if="edit!=='Tracking'">
            <div>
              <div v-for="(trackNum, t) in  (item.TrackingNumber || [])" :key="`track-${t}`">單號{{t+1}}: <a target="__blank" :href="`https://www.t-cat.com.tw/Inquire/TraceDetail.aspx?BillID=${trackNum}`">{{trackNum}}</a></div>
            </div>
            <EditBtnCo @click="edit='Tracking'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='Tracking'">
            <div class="Tracking">
              <div v-for="({}, t) in  (editItem || [])" :key="`track-${t}`">
                <input type="text" v-model="editItem[t]" :placeholder="'請輸入快遞單號'">
                <button class="removeBtn" @click="editItem.splice(t, 1)"><div></div></button>
              </div>
              <div>
                <input type="text" v-model="trackNumEdit" :placeholder="'請輸入快遞單號'" @keypress.enter="addTracking">
                <button class="addBtn" @click="addTracking"><div></div></button>
              </div>
              <BtnsS @cancel="edit=null" @save="addTracking();save()"/>
            </div>
          </template>
        </section>
        <section class="top orders" :label="storeType==='shop'?'預購商品':'預約品項'" v-if="item">
          <template v-if="edit!=='orders'">
            <div>
              <OrderCard v-for="order in item.Orders" :key="order._id" :item="order"/>
            </div>
            <hr class="orders" :style="{marginInline:'20px', width: 'calc(100% - 40px)'}">
            <div class="field2" :style="{display: 'flex', paddingTop:'0'}">
              <div></div>
              <div :style="{fontSize: '16px', fontWeight: 400, letterSpacing: '1.6px'}">總金額 <span :style="{color: 'var(--highlight)', marginInline: '33px 11px', letterSpacing: '2px', fontSize: '20px', fontWeight: 700}"
                >{{item.price||reduce(item.Orders.map(e => priceEach(e)))}}</span> 元</div>
            </div>
            <EditBtnCo v-if="!item.paidTime||item.paidAtERP" @click="edit='orders'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='orders'">
            <div>
              <OrderCardEdit v-for="(order, o) in editItem.Orders" :key="order._id" :item="order" @update="editItem.Orders.splice(o, 1, $event)" @delete="editItem.Orders.splice(o, 1)"/>
              <hr class="hr2">
              <RBtn :text="'新增品項'" :icon="'add'" :bg="'var(--color-checked)'" :style="{marginInline: 'auto', marginBlock: '30px'}" @click="addorders=true"/>
              <hr class="hr2">
            </div>
            <BtnsS @cancel="edit=null" @save="save" :style="{paddingTop: 0}"/>
          </template>
        </section>
        <section class="top" label="訂金資訊">
          <template v-if="item">
          <template v-if="edit!=='remit'">
            <remitVue v-if="item.remit" :item="item.remit" :remitType="item.remitType" :remitTime="item.remitTime" :other="{remit5code: item.remit5code, remitName: item.remitName}"/>
            <remitInfoVue v-else-if="item.remitInfo" :id="item._id" :item="item.remitInfo" :remitTime="item.remitTime||item.reconciledTime"  :message="item.ordererTel ? true : false" @sendMessage="sendMessage('messageTemplate')"
            :other="{remit5code: item.remit5code, remitName: item.remitName}" @cancelEc="cancelEc=$event" @cancelLine="cancelLine=$event"/>
            <remit0Vue v-else-if="item.remitName||item.remit5code||item.remitAmount" :item="{remitType: item.remitType, remit5code: item.remit5code, remitName: item.remitName, remitAmount: item.remitAmount}" :remitTime="item.remitTime"
            :message="item.ordererTel ? true : false" @sendMessage="sendMessage('messageTemplate')"/>
            <div v-else>未付訂</div>
            <template v-if="item.reconciledTime">
              <button class="remitBtn" @click="cancelRemit" :style="{backgroundColor: '#999999'}">取消對帳</button>
            </template>
            <template v-else-if="!item.reconciledTime&&item.remitAmount">
              <button class="remitBtn" @click="confirmRemit" :style="{backgroundColor: 'var(--color-tab)'}">確認對帳</button>
            </template>
            <!-- <div :style="{display: 'flex', flexDirection: 'column', gap: '15px'}" v-if="item.remitInfo">
              <div class="field">
                <div>付訂方式</div>
                <div>{{item.remitInfo.remitType}}</div>
              </div>
              <div class="field">
                <div>付訂日期</div>
                <div>{{item.remitTime ? toDateTime(item.remitTime) : ''}}</div>
              </div>
              <div class="field" v-if="item.remit5code">
                <div>後五碼</div>
                <div>{{item.remit5code||'-'}}</div>
              </div>
              <div class="field" v-else-if="item.remitName">
                <div>戶名</div>
                <div>{{item.remitName||'-'}}</div>
              </div>
              <div class="field">
                <div>訂金金額</div>
                <div><span class="highlight">{{item.remitAmount}}</span> 元</div>
              </div>
            </div>
            <div :style="{display: 'flex', flexDirection: 'column', gap: '15px'}" v-else>
              <div class="field">
                <div>付訂方式</div>
                <div v-if="item.remit">訂金已開立發票</div>
                <div v-else>{{item.remitType}}</div>
              </div>
              <div class="field">
                <div>付訂日期</div>
                <div>{{item.remitTime ? toDateTime(item.remitTime) : ''}}</div>
              </div>
              <div class="field" v-if="item.remit5code">
                <div>後五碼</div>
                <div>{{item.remit5code||'-'}}</div>
              </div>
              <div class="field" v-else-if="item.remitName">
                <div>戶名</div>
                <div>{{item.remitName||'-'}}</div>
              </div>
              <div class="field">
                <div>訂金金額</div>
                <div><span class="highlight">{{item.remitAmount}}</span> 元</div>
              </div>
            </div> -->
            <template v-if="item&&item.reconciler&&item.reconciledTime&&!item.remit">
            <hr :style="{marginBlock: '0px', width: 'calc(100% - 40px)', marginInline: 'auto'}">
            <div class="field-foot" :style="{paddingInline: '20px', marginBottom: '16px'}">
              <div :style="{textAlign:'start'}">對帳人員: {{item.reconciler?.name||'---'}}</div>
              <div :style="{marginLeft: 'auto'}">{{moment(item.reconciledTime).format('yyyy/MM/DD HH:mm')}}</div>
            </div>
            </template>
            <EditBtnCo v-if="!item.paidTime&&!item.remit&&!item.reconciledTime" @click="edit='remit'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='remit'">
            <remitInfoVue v-if="item.remitInfo" :id="item._id" :item="item.remitInfo" :remitTime="item.remitTime||item.reconciledTime"  :message="item.ordererTel ? true : false" @sendMessage="sendMessage('messageTemplate')"
            :other="{remit5code: item.remit5code, remitName: item.remitName}" @cancelEc="cancelEc=$event" @cancelLine="cancelLine=$event"/>
            <div v-else :style="{display: 'flex', flexDirection: 'column', gap: '15px'}">
              <div class="field field-edit">
                <div>付訂方式</div>
                <RT :options="['現金', '匯款']" :defaultValue="editItem.remitType" @input="editItem.remitType=$event"></RT>
              </div>
              <div class="field field-edit">
                <div>付訂日期</div>
                <div><DateInput :style="{width: '230px', margin: 0}" :defaultValue="editItem.remitDate" @input="editItem.remitDate=$event "/></div>
              </div>
              <div class="field field-edit">
                <div>付訂時段</div>
                <div><TimeInput :style="{width: '230px', margin: 0}" :defaultValue="editItem.remitTime" @input="editItem.remitTime=$event "/></div>
              </div>
              <div class="field field-edit">
                <div>後五碼</div>
                <input type="text" v-model="editItem.remit5code">
              </div>
              <div class="field field-edit">
                <div>戶名</div>
                <input type="text" v-model="editItem.remitName">
              </div>
              <div class="field field-edit">
                <div>訂金金額</div>
                <input type="text" v-model="editItem.remitAmount">
              </div>
            </div>
            <button class="remitBtn" @click="createRemit"  :style="{backgroundColor: 'var(--highlight)'}">更新付訂資訊</button>
            <button class="remitBtn" @click="clearRemit"  :style="{backgroundColor: '#AAAAAA'}">清除付訂資訊</button>
            <!-- <Btnsx3Vue @cancel="edit=null"
            @temp="save('已付訂')"  :temp="'確認(已對帳)'"
            @save="save(item.status !== '預約中' && item.status !== '已付訂' ? item.status : '通知付訂')"
            :save="item.status !== '預約中' ? '儲存(更新)' : '儲存(未對帳)'"/> -->
          </template>
          </template>
        </section>
        <section class="top" label="備註" v-if="item">
          <template v-if="edit!=='remark'">
          <div v-html="(item.remark||'').replaceAll('\n', '<br>')"></div>
          <EditBtnCo @click="edit='remark'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='remark'">
            <textarea v-model="editItem.remark"></textarea>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
        </section>
        <section class="top" label="客戶備註" :btnHide="true">
          <template v-if="edit!=='remarkClient'">
          <div v-html="(item?.remarkClient||'').replaceAll('\n', '<br>')"></div>
          <div class="field-foot">
            <div class="ps">※此備註資訊將顯示在客戶訂單資訊中(手機訂單資訊)</div>
          </div>
          <EditBtnCo @click="edit='remarkClient'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='remarkClient'">
            <textarea v-model="editItem.remarkClient"></textarea>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
        </section>
        <section class="top" label="內部備註" v-if="item">
          <template v-if="edit!=='remarkKitchen'">
          <div v-html="(item.remarkKitchen||'').replaceAll('\n', '<br>')"></div>
          <EditBtnCo @click="edit='remarkKitchen'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </template>
          <template v-else-if="edit==='remarkKitchen'">
            <textarea v-model="editItem.remarkKitchen"></textarea>
            <BtnsS @cancel="edit=null" @save="save"/>
          </template>
        </section>
        <section class="top" label="業務經辦(員工)" v-if="item">
          <div v-if="edit!=='salesman'">
          <div :style="{gap: '20px', display: 'flex', flexDirection: 'column'}">
            <div class="field">
              <div>業務來源</div>
              <div :style="{fontWeight: '900', fontSize: '24px', color: 'var(--color-pri)'}">{{item.source||'-'}}</div>
            </div>
            <div class="field">
              <div>業務人員</div>
              <div :style="{fontWeight: '900', fontSize: '24px', color: 'var(--color-pri)'}">{{item.salesman?.name||'-'}}</div>
            </div>
          </div>
          <template v-if="item.salesmanAssign&&item.salesmanAssign.length>0">
            <hr :style="{marginBlock: '17px 10px'}">
            <div class="field-foot"  @click="salesmanAssignDisplay=!salesmanAssignDisplay" :title="`點擊${arrangedDisplay ? '收摺' : '展開'}操作紀錄`">
              <div :style="{textAlign:'start'}">操作人員: {{item.salesmanAssign[item.salesmanAssign.length-1]?.assignBy?.name||'---'}}</div>
              <div :style="{marginLeft: 'auto'}">{{moment(item.salesmanAssign[item.salesmanAssign.length-1].assignTime).format('yyyy/MM/DD HH:mm')}}</div>
            </div>
            <template  v-if="salesmanAssignDisplay">
            <div class="field-foot" v-for="index in item.salesmanAssign.length-1" :key="`history-${index}`" :style="{marginTop: '8px'}">
              <div :style="{textAlign:'start'}">
                來源: {{item.salesmanAssign[item.salesmanAssign.length-(index+1)]?.source||'---'}}
                <br>業務: {{item.salesmanAssign[item.salesmanAssign.length-(index+1)]?.assignTo?.name||'---'}}
              </div>
              <div :style="{marginLeft: 'auto'}">
                操作人員: {{item.salesmanAssign[item.salesmanAssign.length-(index+1)]?.assignBy?.name||'---'}}<br>
                {{moment(item.salesmanAssign[item.salesmanAssign.length-(index+1)].assignTime).format('yyyy/MM/DD HH:mm')}}</div>
            </div>
            </template>
          </template>
          <EditBtnCo @click="edit='salesman'" class="absbtn editbtn1" :style="{top: '7px', right: '13px'}"/>
          </div>
          <template v-else-if="edit==='salesman'">
            <div :style="{gap: '20px', display: 'flex', flexDirection: 'column'}">
              <div class="field field-edit" :style="{gridTemplateColumns: '60px 1fr'}">
                <div :style="{width:'60px'}">來源</div>
                <Select1 :style="{width: '100%'}" :defaultValue="editItem.source" @input="editItem.source=$event ">
                  <option :value="null">請選擇業務來源</option>
                  <option v-for="(sour, s) in source" :key="`sour-${s}`" :value="sour.key">{{sour.key}}</option>
                </Select1>
              </div>
              <div class="field field-edit" :style="{gridTemplateColumns: '60px 1fr'}">
                <div :style="{width:'60px'}">經辦</div>
                <Select1 :style="{width: '100%'}" :defaultValue="editItem.salesman" @input="editItem.salesman=$event ">
                  <option :value="null">請選擇經辦人員</option>
                  <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
                {{sman.department}} | {{sman.post}} | {{sman?.name}}</option>
                </Select1>
              </div>
              <BtnsS @cancel="edit=null" @save="save"/>
            </div>
          </template>
        </section>
        <section v-if="item" :style="{order: -10}">
          <template v-if="edit!=='info'">
          <EditBtn @click="edit='info'" class="absbtn" :style="{backgroundColor: 'var(--color-pri)'}"/>
          <div class="field">
            <div>預約狀態</div>
            <div :style="{fontWeight: '900', fontSize: '24px', color: `var(--${item.status})`}">{{item.status}}</div>
          </div>
          <div class="field">
            <div>預約類型</div>
            <div :style="{fontWeight: '700', fontSize: '24px', color: `var(--${item.type})`}">{{item.type}}</div>
          </div>
          <div class="field">
            <div>{{storeType==='shop'?'取貨':'預約'}}日期</div>
            <div>{{moment(item.visitDate).format('yyyy-MM-DD')}}</div>
          </div>
          <div class="field">
            <div>{{storeType==='shop'?'取貨':'預約'}}時段</div>
            <div>{{item.visitTime}}</div>
          </div>
          <div class="field">
            <div>VIP</div>
            <div :class="item.level===1?'vip':item.level===2?'vvip':item.level===3?'supervip':''"></div>
          </div>
          <div class="field">
            <div>專案名稱</div>
            <div>{{item.project||'-'}}</div>
          </div>
          <div class="field">
            <div>{{storeType==='shop'?'訂購':'預約'}}人</div>
            <div>{{item.orderer||'-'}}</div>
          </div>
          <div class="field">
            <div>聯絡電話</div>
            <div :style="{display:'flex', alignItems:'center'}">{{item.ordererTel||'-'}}
              <button v-if="item.ordererTel" @click="sendMessage('messageTemplate2')" id="sendTextEmpty" class="sendTextMsg">發送簡訊</button>
            </div>
          </div>
          <div class="field">
            <div>會員編號</div>
            <div>{{item.memberID||(item.member&&item.member.memberID)||'-'}}</div>
          </div>
          <div class="field" v-if="item.member">
            <div>會員</div>
            <div>{{(item.member&&item.member.name)}}</div>
          </div>
          <template v-if="storeType==='shop'">
            <div class="field">
              <div>取貨人</div>
              <div>{{item.recipient||'-'}}</div>
            </div>
            <div class="field">
              <div>聯絡電話</div>
              <div>{{item.recipientTel||'-'}}</div>
            </div>
          </template>
          <template v-if="storeType==='tickets'">
          <div class="field">
            <div>領隊</div>
            <div>{{item.recipient||'-'}}</div>
          </div>
          <div class="field">
            <div>聯絡電話</div>
            <div>{{item.recipientTel||'-'}}</div>
          </div>
          </template>
          <template v-if="storeType==='event'&&field2">
          <div class="field">
            <div>{{field2}}</div>
            <div>{{item.recipient||'-'}}</div>
          </div>
          </template>
          <template v-if="storeType==='event'&&field3">
          <div class="field">
            <div>{{field3}}</div>
            <div>{{item.recipientTel||'-'}}</div>
          </div>
          </template>
          <template v-if="item.type==='外送'||item.type==='宅配'">
          <div class="field">
            <div>{{item.type}}地址</div>
            <div>{{item.address||'-'}}</div>
          </div>
          </template>
          <template>
          <div class="field">
            <div>旅行社</div>
            <div>{{item.agencyName||'-'}}</div>
          </div>
          <div class="field">
            <div>統一編號</div>
            <div>{{item.agencyID||'-'}}</div>
          </div>
          <div class="field" v-if="item.InvoiceNo&&item.InvoiceNo.length>0">
            <div>統一發票</div>
            <div>{{item.InvoiceNo.join(',')||'-'}}</div>
          </div>
          </template>
          <template v-if="storeType==='tickets'">
          <div class="field">
            <div>團體名稱</div>
            <div>{{item.groupName||'-'}}</div>
          </div>
          item.InvoiceNo  <div class="field">
            <div>團體類別</div>
            <div>{{item.teamAttributes||'-'}}</div>
          </div>
          <div class="field">
            <div>地區</div>
            <div>{{item.area||'-'}}</div>
          </div>
          </template>
          <div class="field" v-if="storeType==='restaurant'">
            <div>預約人數</div>
            <div v-if="item.reserveNumChild">{{item.reserveNum}} 大 {{item.reserveNumChild}} 小</div>
            <div v-else>{{item.reserveNum}} 人</div>
          </div>
          <div class="internalremark" v-if="member&&member.internalRemark">
            <div>會員備註</div>
            <div>{{member.internalRemark||'-'}}</div>
          </div>
          <hr>
          <div class="field-foot">
            <div v-if="item.createBy&&item.createBy.lineName">預約帳號: {{item.createBy.lineName}}(使用者)</div>
            <div v-else :style="{textAlign:'start'}">接單人員: {{item.createBy?.name||'---'}}</div>
            <div :style="{marginLeft: 'auto'}">{{moment(item.createTime).format('yyyy/MM/DD HH:mm')}}</div>
          </div>
          <div class="field-foot">
            <div :style="{textAlign:'start'}">操作人員: {{item.operator?.name||'---'}}</div>
            <div :style="{marginLeft: 'auto'}">{{moment(item.updateTime).format('yyyy/MM/DD HH:mm')}}</div>
          </div>
          <div class="field-foot" v-if="item.from_source||item.projectId">
            <div >來源: {{item.from_source}}</div>
            <div :style="{marginLeft: 'auto'}">專案ID: {{item.projectId}}</div>
          </div>
          </template>
          <template v-else-if="edit==='info'&&editItem">
            <div class="field field-edit">
              <div>預約狀態</div>
              <Select1 :width="'180px'" :defaultValue="editItem.status" @input="editItem.status=$event ">
                <option v-for="(stat, i) in statuslist" :key="`stat-${i}`" :value="stat">{{stat}}</option>
              </Select1>
            </div>
            <div class="field field-edit">
              <div>預約類型</div>
              <div class="orderTypes">
                <input type="radio" v-for="(stat, i) in types" :key="`stat-${i}`" :class="stat" :value="stat" v-model="editItem.type">
              </div>
            </div>
            <div class="field field-edit">
              <div>{{storeType==='shop'?'取貨':'預約'}}日期</div>
              <div><DateInput :style="{width: '230px', margin: 0}" :defaultValue="moment(editItem.visitDate).format('yyyy-MM-DD')" @input="editItem.visitDate=$event "/></div>
            </div>
            <div class="field field-edit">
              <div>{{storeType==='shop'?'取貨':'預約'}}時段</div>
              <div><TimeInput :style="{width: '230px', margin: 0}" :defaultValue="editItem.visitTime" @input="editItem.visitTime=$event "/></div>
            </div>
            <div class="field field-edit">
              <div>VIP</div>
              <div :style="{gap: '20px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}">
                <input type="radio" class="vip" v-model="editItem.level" :value="1">
                <input type="radio" class="vvip" v-model="editItem.level" :value="2">
                <input type="radio" class="supervip" v-model="editItem.level" :value="3">
                <input type="radio" class="none" v-model="editItem.level" :value="0">
              </div>
            </div>
            <div class="field field-edit">
              <div>專案名稱</div>
              <label for="project-input">
                <input type="text" list="project" id="project-input" v-model="editItem.project">
                <datalist id="project"><option v-for="(pj, j) in projects" :key="j" :value="pj"></option></datalist>
              </label>
            </div>
            <div class="field field-edit">
              <div>專案ID</div>
              <Select1 :style="{width: '220px'}" :defaultValue="editItem.projectId" @input="editItem.projectId=$event;editItem.project=projectsList.find(e => e.projectId===$event)['projectName']; editItem.from_source=null">
                <option :value="null">請選擇專案</option>
                <option v-for="(proj, p) in projectsList" :key="`proj-${p}`" :value="proj.projectId">{{proj.projectName}}</option>
              </Select1>
            </div>
            <div class="field field-edit" v-if="editItem.projectId">
              <div>來源</div>
              <Select1 :key="editItem.projectId" :style="{width: '220px'}" :defaultValue="editItem.from_source" @input="editItem.from_source=$event">
                <option :value="null">請選擇來源</option>
                <option v-for="(tag, t) in selectedProjectTags" :key="`tag-${t}`" :value="tag.name">{{tag.name}}</option>
              </Select1>
            </div>
            <div class="field field-edit">
              <div>{{storeType==='shop'?'訂購':'預約'}}人</div>
              <input type="text" v-model="editItem.orderer">
            </div>
            <div class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.ordererTel">
            </div>
            <template v-if="storeType==='shop'">
            <div class="field field-edit">
              <div>取貨人</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div v-if="storeType==='shop'" class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            </template>
            <template v-if="editItem.type==='宅配'">
            <div class="field">
              <div>宅配地址</div>
              <textarea v-model="editItem.address" :style="{minHeight: '120px'}"></textarea>
            </div>
            </template>

            <template v-if="storeType==='event'">
            <div class="field field-edit" v-if="field2">
              <div>{{field2}}</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div class="field field-edit" v-if="field3">
              <div>{{field3}}</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            </template>
            <template v-if="storeType==='tickets'">
            <div class="field field-edit">
              <div>領隊</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            <div class="field field-edit">
              <div>團體名稱</div>
              <input type="text" v-model="editItem.groupName">
            </div>
            <div class="field field-edit">
              <div>團體類別</div>
              <input type="text" v-model="editItem.teamAttributes">
            </div>
            <div class="field field-edit">
              <div>地區</div>
              <Select1 :defaultValue="editItem.area" @input="editItem.area=$event">
                <option :value="null">地區</option>
                <option v-for="(country, c) in countries" :key="`countries-${c}`" :value="country">{{country}}</option>
              </Select1>
            </div>
            </template>
            <div class="field field-edit" :style="{zIndex: 6}">
              <div>會員編號</div>
              <div class="flexrow" :style="{gap: '8px'}">
                <div class="inputtext" :style="{width: '-webkit-fill-available', border: '1px solid #CACACA', height: '40px', borderRadius: '3px'}">
                  {{editItem.member?.memberID||editItem.memberID}}
                </div>
                <Sqr40016w :icon="'book'" :bg="'var(--color-pri)'" @click="getMember=!getMember"></Sqr40016w>
              </div>
              <!-- <div class="agency-box" v-if="editItem.member&&editItem.member._id"><div>{{editItem.member.name}}</div><button :style="{zIndex: 2}" @click="clearmember" class="removebtn"></button></div>
              <label v-else for="member-input" :style="{width: '220px'}">
                <input type="text" id="member-input" v-model="memberText">
                <div class="ul">
                  <div class="li" v-for="(ag, j) in members" :key="`member-${j}`" @click="editItem.member=JSON.parse(JSON.stringify(ag));members=[];memberText=null"><div>{{ag.memberID || '------------'}}</div><div :style="{borderLeft: '1px solid', paddingLeft: '10px'}">{{ag.name}}</div></div>
                </div>
              </label> -->
            </div>
            <div class="field field-edit" :style="{zIndex: 6}" v-if="editItem.member">
              <div>會員姓名</div>
              <div>{{editItem.member?.name||editItem.memberID}}</div>
            </div>
            <div class="field field-edit">
              <div>旅行社</div>
              <div class="flexrow" :style="{gap: '8px'}">
                <div class="inputtext" :style="{width: '-webkit-fill-available', border: '1px solid #CACACA', height: '40px', borderRadius: '3px'}">
                  {{editItem.agency?.name||editItem.agencyName}}
                </div>
                <Sqr40016w :icon="'book'" :bg="'var(--color-pri)'" @click="getAgency=!getAgency"></Sqr40016w>
              </div>
            </div>
            <div class="field field-edit"  v-if="storeType==='restaurant'">
              <div>預約人數</div>
              <div :style="{justifyContent: 'space-between', display: 'flex'}">
                <input type="text" v-model="editItem.reserveNum" :style="{width: '80px', textAlign: 'center'}">大
                <input type="text" v-model="editItem.reserveNumChild" :style="{width: '80px', textAlign: 'center'}">小
              </div>
            </div>
            <BtnsS :style="{marginTop: '15px'}" @cancel="edit=null" @save="save"/>
          </template>
          <template>
          </template>
        </section>
      </div>
    </infoSlider>
      <agSelector :show="getAgency" :items="agencyText ? [{taxID: agencyText, name: agencyText}, ...agenciesShort] : [{taxID: null, name: ''}, ...agenciesShort]" @search="agencyText=$event" :search="agencyText">
        <div slot-scope="{item}" @click="editItem.agency=JSON.parse(JSON.stringify(item));getAgency=false">
          <div>{{item.name}}</div>
        </div>
      </agSelector>
      <agSelector :show="getMember" :items="members" @search="memberText=$event" :search="memberText">
        <div slot-scope="{item}" @click="editItem.member=JSON.parse(JSON.stringify(item));getMember=false" :style="{gap: '20px'}">
          <div>{{item.mobile || '------------'}}</div> <div>{{item.name}}</div>
        </div>
      </agSelector>
    <AddOrders v-if="addorders" @close="addorders=false" :products="products" @add="addorder" :agencyID="item.member?.verified&&item.member.role==='shop'&&item.member?.agencyID "/>
    <moveInfoVue v-if="movingInfo&&item" @close="movingInfo=false" :item="item" @moved="moved"/>
    <DialogVue :style="{position:'fixed'}" :show="cancelEc" v-if="cancelEc" label="綠界交易資訊" @close="cancelEc=null">
      <DialogEC :data="cancelEc.data" @close="cancelEc=null" @refund="refundEcPay()"/>
    </DialogVue>
    <DialogVue :style="{position:'fixed'}" :show="cancelLine" v-if="cancelLine" label="LINEPAY交易資訊" @close="cancelLine=null">
      <DialogLY :data="(cancelLine?.data || [])[0] || null" :error="cancelLine.codeMsg" :transactionId="cancelLine.transactionId" @close="cancelLine=null" @refund="refundLinePay"/>
    </DialogVue>
  </div>
</template>

<script>
import remitVue from './box/remit.vue'
import remit0Vue from './box/remit0.vue'
import remitInfoVue from './box/remitInfo.vue'
import agSelector from './agencySelector.vue'
import RBtn from '../../components/btn/round.vue'
import AddOrders from './AddOrders.vue'
import moveInfoVue from './moveInfo.vue'
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
import OrderCard from './orderCard.vue'
import OrderCardEdit from './orderCardEdit.vue'
import EditBtn from '../../components/btn/edit.vue'
import EditBtnCo from '../../components/btn/editConvert.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import { postapi, getapi } from '../../store/fetch'
import { mapState } from 'vuex'
import Sqr40016w from '../../components/btn/sqr30016wb.vue'
// import Btnsx3Vue from '../../components/btn/btnsx3.vue'
import DialogLY from './dialog/lyinfo.vue'
import DialogEC from './dialog/ecinfo.vue'
import DialogVue from '../../components/dialognoPadding2.vue'
export default {
  props: ['item', 'salesmans', 'projects', 'statuslist', 'products', 'types', 'store', 'storeType', 'field2', 'field3', 'source', 'messageTemplate', 'messageTemplate2'],
  components: {
    DialogLY,
    DialogEC,
    DialogVue,
    moveInfoVue,
    // Btnsx3Vue,
    agSelector,
    RBtn,
    infoSlider,
    EditBtn,
    EditBtnCo,
    OrderCard,
    OrderCardEdit,
    DateInput,
    TimeInput,
    AddOrders,
    Sqr40016w,
    remit0Vue,
    remitVue,
    remitInfoVue
  },
  data () {
    return {
      cancelEc: null,
      cancelLine: null,
      movingInfo: false,
      arrangedDisplay: false,
      salesmanAssignDisplay: false,
      getAgency: false,
      getMember: false,
      addorders: false,
      edit: null,
      editItem: null,
      agencyText: null,
      agenciesShort: [],
      memberText: null,
      members: [],
      trackNumEdit: null,
      projectsList: []
    }
  },
  watch: {
    item: {
      handler () {
        this.edit = null
        this.arrangedDisplay = false
        this.salesmanAssignDisplay = false
      },
      deep: true
    },
    agencyText () {
      this.getagenciesShort()
    },
    getAgency () {
      if (this.getAgency) {
        this.getMember = false
        this.getagenciesShort()
      }
    },
    getMember () {
      if (this.getMember) {
        this.getAgency = false
        this.getMembers()
      }
    },
    memberText () {
      this.getMembers()
    },
    edit () {
      switch (this.edit) {
        case 'guide2':
          this.editItem = { reserveNumChild: this.item.reserveNumChild, reserveNum: this.item.reserveNum }
          break
        case 'guide':
          this.editItem = { guideNeed: this.item.guideNeed, reserveNum: this.item.reserveNum }
          break
        case 'orders':
          this.editItem = { Orders: JSON.parse(JSON.stringify(this.item.Orders)) }
          break
        case 'remark':
          this.editItem = { remark: this.item.remark }
          break
        case 'remarkClient':
          this.editItem = { remarkClient: this.item.remarkClient }
          break
        case 'remarkKitchen':
          this.editItem = { remarkKitchen: this.item.remarkKitchen }
          break
        case 'salesman':
          this.editItem = { salesman: this.item.salesman?._id || null, source: this.item.source || null }
          break
        case 'signDate':
          this.editItem = { productionDate: this.moment(this.item.productionDate).format('yyyy-MM-DD') }
          break
        case 'remit':
          this.editItem = {
            remitType: this.item.remitType || '匯款',
            remit5code: this.item.remit5code || null,
            remitName: this.item.remitName || null,
            remitDate: this.item.remitTime ? this.toDate(this.item.remitTime) : null,
            remitTime: this.item.remitTime ? this.moment(this.item.remitTime).format('HH:mm') : null,
            remitAmount: this.item.remitAmount || null
          }
          break
        case 'Tracking':
          this.editItem = JSON.parse(JSON.stringify(this.item.TrackingNumber || []))
          break
        case 'info':
          this.getProjectsList()
          this.editItem = {
            address: this.item.address,
            type: this.item.type,
            status: this.item.status,
            visitDate: this.item.visitDate,
            visitTime: this.item.visitTime,
            orderer: this.item.orderer,
            ordererTel: this.item.ordererTel,
            recipient: this.item.recipient,
            recipientTel: this.item.recipientTel,
            level: this.item.level,
            project: this.item.project,
            projectId: this.item.projectId,
            from_source: this.item.from_source,
            reserveNum: (this.item.reserveNum || 0),
            reserveNumChild: (this.item.reserveNumChild || 0),
            member: this.item.member ? JSON.parse(JSON.stringify(this.item.member)) : null,
            agency: {
              taxID: this.item.agencyID || this.item.agencyName,
              name: this.item.agencyName || this.item.agencyID
            }
          }
          if (this.storeType === 'tickets') {
            this.editItem.groupName = this.item.groupName
            this.editItem.teamAttributes = this.item.teamAttributes
            this.editItem.area = this.item.area
          }
          this.agencyText = null
          break
        default:
          this.editItem = null
          this.getAgency = false
          this.getMember = false
          break
      }
    }
  },
  computed: {
    member () {
      return this.item && (this.item.member || this.item.ordererID)
    },
    selectedProjectTags () {
      if (!this.editItem || !this.editItem.projectId) return []
      const proj = this.projectsList.find(p => p.projectId === this.editItem.projectId)
      return proj ? proj.tags : []
    },
    ...mapState({
      countries: 'countries'
    })
  },
  methods: {
    async getProjectsList () {
      this.projectsList = await getapi(`projects/store/${this.store}`) || []
    },
    async cancelRemit () {
      const r = await postapi(`restaurant/cancelConfirmRemit/${this.item._id}`)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    async confirmRemit () {
      const r = await postapi(`restaurant/confirmRemit/${this.item._id}`)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    async clearRemit () {
      const r = await postapi(`restaurant/clearRemit/${this.item._id}`)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    async createRemit () {
      if ((!this.editItem.remit5code && !this.editItem.remitName) || !this.editItem.remitDate || !this.editItem.remitTime || !this.editItem.remitAmount) {
        return false
      }
      const params = { ...this.editItem }
      params.remitTime = this.moment(`${this.editItem.remitDate} ${this.editItem.remitTime}`).toISOString()
      const r = await postapi(`restaurant/createRemit/${this.item._id}`, params)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    sendMessage (key) {
      const visitDate = this.moment(this.item.visitDate).format('yyyy年MM月DD日')
      const visitTime = this.item.visitTime
      const reserveNum = this.item.reserveNum
      const reserveNumChild = this.item.reserveNumChild
      const remitAmount = this.item.remitAmount + '元'
      const template = (this[key] || '')
        .replaceAll('{匯款金額}', remitAmount)
        .replaceAll('{預約日期}', visitDate)
        .replaceAll('{預約時間}', visitTime)
        .replaceAll('{大人小孩}', `${reserveNum || 0}大${reserveNumChild || 0}小`)
        .replaceAll('{人數}', this.reduce([reserveNum, reserveNumChild]))
        .replaceAll('{匯款金額}', remitAmount)
      this.$emit('sendMessage', { text: template, phone: this.item.ordererTel })
    },
    async refundLinePay () {
      const id = this.item._id
      const r = await postapi(`payment/linepay/refund/${id}`)
      if (r) {
        this.item.remitInfo = r.remitInfo
        this.item.status = r.status
        this.$emit('remitUpdate', r)
        this.cancelLine = null
      }
    },
    async refundEcPay () {
      const id = this.item._id
      const r = await postapi(`payment/ecpay/refund/${id}`)
      if (r) {
        this.item.remitInfo = r.remitInfo
        this.item.status = r.status
        this.$emit('remitUpdate', r)
        this.cancelEc = null
      }
    },
    moved (ev) {
      this.$router.replace({ name: this.$route.name, query: { page: ev.store, date: this.toDate(ev.visitDate) } })
      this.movingInfo = false
      this.$emit('close')
    },
    addorder (ev) {
      console.log(ev)
      console.table([...[].concat(...this.editItem.Orders.map(e => e.items)), ...ev.items])
      this.editItem.Orders.push(ev)
    },
    async getMembers () {
      if (this.memberText || this.getMember) {
        const params = {}
        if (this.memberText) {
          params.Search = this.memberText
        }
        this.members = await getapi('users/recent?' + new URLSearchParams(params))
      } else {
        this.members = []
      }
    },
    async getagenciesShort () {
      if (this.agencyText || this.getAgency) {
        const params = {}
        if (this.agencyText) {
          params.search = this.agencyText
        }
        this.agenciesShort = await getapi(`agencies/short?${new URLSearchParams(params)}`)
      } else {
        this.agenciesShort = []
      }
    },
    test () {
      console.table(this.editItem.Orders)
      console.table([].concat(...this.editItem.Orders.map(e => e.items)))
      console.table([].concat(...this.editItem.Orders.map(e => [].concat(...e.items.map(a => a.add)))))
      // const orders = this.editItem.Orders
    },
    addTracking () {
      if (this.trackNumEdit) {
        this.editItem.push(this.trackNumEdit)
        this.editItem = Array.from(new Set(this.editItem))
      }
      this.trackNumEdit = null
    },
    async save (status) {
      let params = {}
      switch (this.edit) {
        case 'guide2':
          params = { ...this.editItem }
          break
        case 'guide':
          params = { ...this.editItem }
          break
        case 'salesman':
          params = { ...this.editItem }
          break
        case 'info':
          params = { ...this.editItem }
          params.agencyID = (params.agency && params.agency.taxID) || this.agencyText
          break
        case 'signDate':
          params = { ...this.editItem }
          params.productionDate = params.productionDate ? this.moment(params.productionDate).startOf('day').toISOString() : null
          if (params.productionDate && this.item.status === '新訂單') params.status = '待出貨'
          break
        case 'orders':
          params.Orders = this.editItem.Orders
          if (params.Orders.filter(e => /導覽/ig.test(e.name)).length > 0) params.guideNeed = true
          break
        case 'Tracking':
          params = { TrackingNumber: this.editItem.filter(e => e) }
          break
        case 'remit':
          if ((!this.editItem.remit5code && !this.editItem.remitName) || !this.editItem.remitDate || !this.editItem.remitTime || !this.editItem.remitAmount) {
            return false
          }
          params = { ...this.editItem, status }
          params.remitTime = this.moment(`${this.editItem.remitDate} ${this.editItem.remitTime}`).toISOString()
          break
        default:
          params[this.edit] = this.editItem[this.edit]
          break
      }
      console.log(this.edit, params)
      const ret = await postapi(`restaurant/${this.item._id}`, params)
      if (ret) {
        this.$emit('updateItem', ret)
        this.addorders = false
        this.edit = null
      }
    }
  }
}
</script>
<style lang="scss">
#moveInfo {
  background-color: #7FA7DA;
  color: #FFFFFF;
  height: 40px;
  min-width: 120px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: .1em;
  border-radius: 3px;
  padding: 10px;
}
.editbtn1 {
  &.absbtn {
    width: 32px;
    height: 32px;
    &::before {
      background-color: var(--color-pri);
    }
  }
}
</style>
<style lang="scss" scoped>
*, *::before, *::after {
  box-sizing: border-box;
}
button.remitBtn {
  margin-inline: 20px;
  height: 50px;
  background-color: var(--color-checked);
  color: #FFFFFF;
  letter-spacing: .1em;
  font-size: 20px;
  border-radius: 3px;
  margin-bottom: 20px;
}
.Tracking {
  display: flex;
  flex-direction: column;
  gap: 15px;
  &>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  input[type=text] {
    width: 310px;
    height: 50px;
    border: 1px solid #CACACA;
    padding-inline: 1em;
    font-size: 20px;
  }
  button {
    width: 50px;
    height: 50px;
    background-color: var(--color-checked);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    div {
      width: 30px;
      height: 30px;
      background-color: #FFFFFF;
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
    }
    &.removeBtn > div {
      mask-image: url(/svg/btn/del1.svg);
    }
    &.addBtn > div {
      mask-image: url(/svg/btn/add.svg);
    }
  }
}
#sendTextEmpty {
  margin-left: auto;
  background-color: var(--color-checked);
  color: #FFFFFF;
  padding: .1em .5em;
  border-radius: 3px;
}
.fieldGu {
  label {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 30px;
    font-size: 18px;
  }
  input[type=radio] {
    width: 20px;
    height: 20px;
    appearance: none;
    border: 2px solid var(--color-pri);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:checked::after {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: var(--color-pri);
    }
  }

}
.signDate {
  color: var(--unnamed, #FF8B8B);
  font-family: Noto Sans TC;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3px;
  text-align: center;
}
.highlight {
  color: #FF7373;
  font-weight: 700;
  font-size: 24px;
}
.orderTypes {
  display: flex;
  align-items: center;
  gap: 10px;
}
.orderTypes > input {
  appearance: none;
  width: fit-content;
  height: 39px;
  background: #FFFFFF;
  border: 1.5px solid;
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  &::before {
    content: attr(value);
  }
  &.男 {
    border: 1.5px solid var(--男);
    color:  var(--男);
    &:checked {
      background-color: var(--男);
    }
  }
  &.女 {
    border: 1.5px solid var(--女);
    color:  var(--女);
    &:checked {
      background-color: var(--女);
    }
  }
  &.戶外證婚 {
    border: 1.5px solid var(--戶外證婚);
    color:  var(--戶外證婚);
    &:checked {
      background-color: var(--戶外證婚);
    }
  }
  &.婚紗攝影 {
    border: 1.5px solid var(--婚紗攝影);
    color:  var(--婚紗攝影);
    &:checked {
      background-color: var(--婚紗攝影);
    }
  }
  &.內用 {
    border: 1.5px solid var(--內用);
    color:  var(--內用);
    &:checked {
      background-color: var(--內用);
    }
  }
  &.外帶 {
    border: 1.5px solid var(--外帶);
    color:  var(--外帶);
    &:checked {
      background-color: var(--外帶);
    }
  }
  &.自取 {
    border: 1.5px solid var(--自取);
    color:  var(--自取);
    &:checked {
      background-color: var(--自取);
    }
  }
  &.宅配 {
    border: 1.5px solid var(--宅配);
    color:  var(--宅配);
    &:checked {
      background-color: var(--宅配);
    }
  }
  &.現場 {
    border: 1.5px solid var(--現場);
    color:  var(--現場);
    &:checked {
      background-color: var(--現場);
    }
  }
  &.線上 {
    border: 1.5px solid var(--線上);
    color:  var(--線上);
    &:checked {
      background-color: var(--線上);
    }
  }
  &:checked {
    color: #FFFFFF;
  }
}

div.vip, div.vvip, div.supervip {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
}

div.vip {
  background-image: url(/vip.svg);
  mask-image: none;
}
div.supervip {
  background-image: url(/supervip.svg);
  mask-image: none;
}
div.vvip {
  background-image: url(/vvip.svg);
  mask-image: none;
}
input.vip, input.vvip, input.supervip, .none {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: transparent;
  filter: contrast(.5);
  &:checked {
    filter: contrast(1);
  }
}
input.vip {
  background-image: url(/vip.svg);
}
input.vvip {
  background-image: url(/vvip.svg);
}
input.supervip {
  background-image: url(/supervip.svg);
}
.none {
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
  background-color: #CACACA;
  filter: contrast(1);
  &:checked {
    background-color: transparent;
  }
}
.hr2 {
  margin: .5em 0;
  border-block: 3px solid #FFFFFF;
  border-inline: 8px solid var(--color-pri);
  background-color: var(--color-pri);
  height: 8px;
}
.editbox {
  position: var(--dialogPosition);
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
label {
  position: relative;
  z-index: 1;
}
.ul {
  position: absolute;
  right: 0;
  width: 350px;
  background-color: #FFFFFF;
  max-height: 230px;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 99;
  .li {
    padding-block: 7.25px;
    padding-inline: .75em;
    min-height: 55px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 40px;
    &:hover {
      background-color: #CACACA;
    }
  }
}
.removebtn {
  margin-left: auto;
  height: 40px;
}
.absbtn {
  position: absolute;
  top: 20px;
  right: 18px;
}
.agency-box {
  display: flex;
  align-items: center;
  height: 40px;
  padding-inline: .75em;
  border: 1px solid #CACACA;
  border-radius: 3px;
  font-size: 18px;
  button {
    background-color: #CACACA;
    width: 23px;
    mask-image: url(/svg/btn/close.svg);
    mask-size: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    border: none;
    outline: 1px solid #CACACA;
    box-sizing: content-box;
    padding: 0;
  }
}
.internalremark {
  display: flex;
  flex-direction: column;
  gap: 6px;
  &>:nth-child(1) {
    font-weight: 400;
    font-size: 16px;
    line-height: 180%;
    color: #FFFFFF;
    width: 125px;
    height: 30px;
    background: #FF7373;
    border-radius: 50px;
  }
  &>:nth-child(2) {
    text-align: start;
    font-weight: 400;
    font-size: 15px;
    line-height: 180%;
    color: #FF7373;
  }
}
.field-foot {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
  letter-spacing: 0;
  &>div:nth-child(1) {
    text-align: start;
  }
  &>div:nth-child(2) {
    text-align: end;
  }
}
hr.orders {
  border-inline: 6px solid var(--color-pri);
  background-color: var(--color-pri);
  border-block: 4px solid #FFFFFF;
  height: 10px;
}
hr {
  height: 1px;
  border: none;
  background-color:#CACACA;
  width: 100%;
  margin: 0;
}
.flexrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.field2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
}
.field {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 28px;
  &.field-edit {
    line-height: 35px;
  }
  &>:nth-child(1) {
    text-align: end;
  }
  &>:nth-child(2) {
    text-align: start;
  }
  input[type=text], textarea, .inputtext {
    width: 220px;
    height: 40px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding-inline: .75em;
    box-sizing: border-box;
    font-size: 18px;
    color: #5E5E5E;
  }
  .inputtext {
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    text-align: start;
    align-items: center;
    max-width: 220px;
    &::-webkit-scrollbar {
      height: 0;
    }
  }
  textarea {
    padding-block: .5em;
  }
}
section {
  max-width: 426px;
  position: relative;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  padding: 20px 20px 13px 23px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  display: flex;
  flex-direction: column;
  gap: 11px;
  height: fit-content;
}
.ps {
  height: 2em;
  line-height: 1em;
  width: 100%;
  padding-inline: 1em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-top: 1px solid #B9B9B9;
}
section.top {
  padding: 0;
  &::before {
    content: attr(label);
    display: inline;
    width: 100%;
    height: 45px;
    background-color: var(--color-pri);
    color: #FFFFFF;
    text-align: start;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    padding-inline: 28px;
  }
  &>div:not(.field-foot), &>textarea{
    border: none;
    height: fit-content;
    padding: 21px 13px 21px 28px;
    text-align: start;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #787878;
  }
  textarea {
    min-height: 200px;
  }
}
section.orders>div:nth-child(1) {
  gap: 15px;
  display: flex;
  flex-direction: column;
}
.editCube {
  flex: 1;
  padding: 31px 20px 30px 30px;
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  margin-right: 8px;
  height: 100%;
  overflow-y: auto;
  align-content: flex-start;
  gap: 19px;
}
</style>
